import { render, staticRenderFns } from "./UserStaking.vue?vue&type=template&id=6d0f1531&"
import script from "./UserStaking.vue?vue&type=script&lang=js&"
export * from "./UserStaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports